export const RECEIVED_SENSORS = "RECEIVED_SENSORS";
export const RECEIVED_HISTORY = "RECEIVED_HISTORY";
export const SAVED_SENSOR_NAME = "SAVED_SENSOR_NAME";
